import config from './config.js';
import getEnv from './env.js';

export function getPath() {
    const envName = getEnv();

    // 模块自定义配置
    const envObj = config.env[envName];

    return {
        ajax: `${location.protocol}//${envObj.serverDomain}`,
        rmsAjax: `${location.protocol}//${envObj.rmsDomain}`,
        serverDomain: `${location.protocol}//${envObj.serverDomain}`,
        domain: `${location.protocol}//${envObj.domain}`,
    };
}



// WEBPACK FOOTER //
// ./lib/path.js